
import { Component, Mixins, Prop } from 'vue-property-decorator';
import SectionStyling from '~/mixins/SectionStyling';

interface IBulletPoint {
	icon: string;
	headline: string;
	subline: string;
	text: string;
}

@Component({ name: 'HowItWorksSection' })
export default class HowItWorksSection extends Mixins(SectionStyling) {
	@Prop({ type: String }) readonly headline!: string;

	@Prop({ type: Boolean }) readonly card?: boolean;

	@Prop({ type: Boolean, default: false }) readonly showButton?: boolean;

	@Prop({ type: Array, required: true }) readonly items!: IBulletPoint[];

	@Prop({
		type: String,
		required: false,
		default: 'white',
		validator: (value: string) => ['white', 'grey', 'light'].includes(value)
	})
	readonly cardColor!: string;

	get hideIcons(): boolean {
		return !this.items.some(item => item.icon);
	}

	get cardClasses(): string[] {
		if (!this.card) {
			return [];
		}
		const classList = ['px-5 sm:px-8 py-8 sm:py-10 rounded-lg'];
		switch (this.cardColor) {
			case 'light':
				classList.push('bg-color-main-light');
				break;
			case 'grey':
				classList.push('bg-color-grey-lightest');
				break;
			case 'white':
			default:
				classList.push('bg-color-white');
		}
		return classList;
	}

	trackingAndRedirect() {
		this.$trackWebsiteEvent('go_to_pricing_page', { pageElement: 'our_success' });
		this.$emit('clicked-cta');
	}
}
